import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=04e17028&"
import script from "./CarInfo.vue?vue&type=script&lang=ts&"
export * from "./CarInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CarInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports